import config from '../config/config.json'
import superagent from 'superagent'
import * as c from '../constants/actionTypes';

const UPDATE_TAB = 'UPDATE_TAB'

export { UPDATE_TAB }

export function updateTab(index) {
  return {
    type: UPDATE_TAB,
    index: index
  }
}

const UPDATE_USERID_INPUT = 'UPDATE_USERID_INPUT'
export { UPDATE_USERID_INPUT }
export function updateUserIdInput(key, value) {
  return {
    type: UPDATE_USERID_INPUT,
    key: key,
    value: value
  }
}

const UPDATE_POPUP = 'UPDATE_POPUP'

export { UPDATE_POPUP }

export function updatePopup(state) {
  return {
    type: UPDATE_POPUP,
    state: state
  }
}

const UPDATE_TAB_POPUP = 'UPDATE_TAB_POPUP'

export { UPDATE_TAB_POPUP }

export function updatePopupTab(index) {
  return {
    type: UPDATE_TAB_POPUP,
    index: index
  }
}

const UPDATE_SUBMISSION_INPUT = 'UPDATE_SUBMISSION_INPUT'

export {
  UPDATE_SUBMISSION_INPUT
}

export function updateSubmissionInput(index, key, value) {
  return {
    type: UPDATE_SUBMISSION_INPUT,
    index: index,
    key: key,
    value: value
  }
}


// REQUEST RATING INFORMATION ----------------------------------------------------------------------
const RATING_DETAILS_REQUEST = 'RATING_DETAILS_REQUEST'
const RATING_DETAILS_SUCCESS = 'RATING_DETAILS_SUCCESS'
const RATING_DETAILS_FAILURE = 'RATING_DETAILS_FAILURE'

export {
  RATING_DETAILS_REQUEST,
  RATING_DETAILS_SUCCESS,
  RATING_DETAILS_FAILURE
}

export function getRatingRequest() {
  return {
    type: RATING_DETAILS_REQUEST,
    loading: true
  }
}

export function getRatingSuccess(body) {
  return {
    type: RATING_DETAILS_SUCCESS,
    body: body,
    loading: false
  }
}

export function getRatingFailure(error) {
  return {
    type: RATING_DETAILS_FAILURE,
    error: error,
    loading: false
  }
}

export function getRatingDetails(body, cb) {
  return function(dispatch) {
    dispatch(getRatingRequest())
    superagent
    .get(config.BASE + 'api/getratingdetails')
    .query({ doc_id: body })
    .withCredentials()
    .end((err, res) => {
      if (err) {
        //alert("Error getting rating")
        dispatch(getRatingFailure(err))
      } else {
        dispatch(getRatingSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

// Cancel Edit Request --------------------------------------------------------
const CANCEL_EDITREQUEST_REQUEST = 'CANCEL_EDITREQUEST_REQUEST'
const CANCEL_EDITREQUEST_SUCCESS = 'CANCEL_EDITREQUEST_SUCCESS'
const CANCEL_EDITREQUEST_FAILURE = 'CANCEL_EDITREQUEST_FAILURE'

export {
  CANCEL_EDITREQUEST_REQUEST,
  CANCEL_EDITREQUEST_SUCCESS,
  CANCEL_EDITREQUEST_FAILURE
}

export function cancelEditRequestRequest() {
  return {
    type: CANCEL_EDITREQUEST_REQUEST,
    loading: true
  }
}

export function cancelEditRequestSuccess(body) {
  return {
    type: CANCEL_EDITREQUEST_SUCCESS,
    body: body,
    loading: false
  }
}

export function cancelEditRequestFailure(error) {
  return {
    type: CANCEL_EDITREQUEST_FAILURE,
    error: error,
    loading: false
  }
}

export function cancelEdit(doc_id, cb) {
  return function(dispatch) {
    let tempbody = {
        doc_id: doc_id
    }
    console.log('inside canceledit');
    console.log(doc_id);
    console.log(tempbody);
    dispatch(cancelEditRequestRequest())
    superagent
    .post(config.BASE + 'api/canceledit')
    .send(tempbody)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        //alert("Error updating invoice")
        dispatch(cancelEditRequestFailure(err))
      } else {
        //alert("Edit Cancelled!  ")
        dispatch(cancelEditRequestSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

// UPDATE INVOICE PAID (ADMIN ) ---------------------------------------------
const UPDATE_INVOICEPAID_REQUEST = 'UPDATE_INVOICEPAID_REQUEST'
const UPDATE_INVOICEPAID_SUCCESS = 'UPDATE_INVOICEPAID_SUCCESS'
const UPDATE_INVOICEPAID_FAILURE = 'UPDATE_INVOICEPAID_FAILURE'

export {
  UPDATE_INVOICEPAID_REQUEST,
  UPDATE_INVOICEPAID_SUCCESS,
  UPDATE_INVOICEPAID_FAILURE
}

export function updateInvoicePaidRequest() {
  return {
    type: UPDATE_INVOICEPAID_REQUEST,
    loading: true
  }
}

export function updateInvoicePaidSuccess(body) {
  return {
    type: UPDATE_INVOICEPAID_SUCCESS,
    body: body,
    loading: false
  }
}

export function updateInvoicePaidFailure(error) {
  return {
    type: UPDATE_INVOICEPAID_FAILURE,
    error: error,
    loading: false
  }
}

export function updateInvoicePaid(body, cb) {
  return function(dispatch) {
    dispatch(updateInvoicePaidRequest())
    superagent
    .post(config.BASE + 'api/admin/updateinvoicepaid')
    .send(body)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        //alert("Error updating invoice")
        dispatch(updateInvoicePaidFailure(err))
      } else {
        dispatch(updateInvoicePaidSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

//Submit Rating ------------------------------------------------------------
const SUBMIT_RATING_REQUEST = 'SUBMIT_RATING_REQUEST'
const SUBMIT_RATING_SUCCESS = 'SUBMIT_RATING_SUCCESS'
const SUBMIT_RATING_FAILURE = 'SUBMIT_RATING_FAILURE'

export {
  SUBMIT_RATING_REQUEST,
  SUBMIT_RATING_SUCCESS,
  SUBMIT_RATING_FAILURE
}

export function SubmitRatingRequest() {
  return {
    type: SUBMIT_RATING_REQUEST,
    loading: true
  }
}

export function SubmitRatingSuccess(body) {
  return {
    type: SUBMIT_RATING_SUCCESS,
    body: body,
    loading: false
  }
}

export function SubmitRatingFailure(error) {
  return {
    type: SUBMIT_RATING_FAILURE,
    error: error,
    loading: false
  }
}

export function SubmitRating(body, cb) {
  return function(dispatch) {
    console.log(body)
    console.log("<--------- submit rating --------->")
    dispatch(SubmitRatingRequest())
    superagent
    .post(config.BASE + 'api/student/rating')
    .send(body)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        //alert("Error Submitting Rating")
        dispatch(SubmitRatingFailure(err))
      } else {
        dispatch(SubmitRatingSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}


//  GET MY INVOICES -------------------------------------------------------
const GET_INVOICES_REQUEST = 'GET_INVOICES_REQUEST'
const GET_INVOICES_SUCCESS = 'GET_INVOICES_SUCCESS'
const GET_INVOICES_FAILURE = 'GET_INVOICES_FAILURE'

export {
  GET_INVOICES_REQUEST,
  GET_INVOICES_SUCCESS,
  GET_INVOICES_FAILURE
}

export function getInvoicesRequest() {
  return {
    type: GET_INVOICES_REQUEST,
    loading: true
  }
}

export function getInvoicesSuccess(body) {
  return {
    type: GET_INVOICES_SUCCESS,
    body: body,
    loading: false
  }
}

export function getInvoicesFailure(error) {
  return {
    type: GET_INVOICES_FAILURE,
    error: error,
    loading: false
  }
}

export function getInvoices(body, cb) {
  return function(dispatch) {
    dispatch(getInvoicesRequest())
    superagent
    .get(config.BASE + 'api/getinvoices')
    .withCredentials()
    .end((err, res) => {
      if (err) {
        //alert("Error updating invoice")
        dispatch(getInvoicesFailure(err))
      } else {
        dispatch(getInvoicesSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}
// ------

const UPDATE_INVOICE_ARRAY = 'UPDATE_INVOICE_ARRAY'
export {
  UPDATE_INVOICE_ARRAY
}

export function invoiceSelect(i){
  return{
    type: UPDATE_INVOICE_ARRAY,
    docid: i
  }
}

const GENERATE_INVOICE_REQUEST = 'GENERATE_INVOICE_REQUEST'
const GENERATE_INVOICE_SUCCESS = 'GENERATE_INVOICE_SUCCESS'
const GENERATE_INVOICE_FAILURE = 'GENERATE_INVOICE_FAILURE'

export {
  GENERATE_INVOICE_REQUEST,
  GENERATE_INVOICE_SUCCESS,
  GENERATE_INVOICE_FAILURE
}

export function generateInvoiceRequest() {
  return {
    type: GENERATE_INVOICE_REQUEST,
    loading: true
  }
}

export function generateInvoiceSuccess(body) {
  return {
    type: GENERATE_INVOICE_SUCCESS,
    body: body,
    loading: false
  }
}

export function generateInvoiceFailure(error) {
  return {
    type: GENERATE_INVOICE_FAILURE,
    error: error,
    loading: false
  }
}

export function generateInvoice(body, cb) {
  return function(dispatch) {
    dispatch(generateInvoiceRequest())
    superagent
    .post(config.BASE + 'api/generateinvoice')
    .send(body)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        //alert("Error generating invoice")
        dispatch(generateInvoiceFailure(err))
      } else {
        //alert("Success Generating Invoices!")
        dispatch(generateInvoiceSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

const UPDATE_MYSUBMISSION_INPUT = 'UPDATE_MYSUBMISSION_INPUT'

export {
  UPDATE_MYSUBMISSION_INPUT
}

export function updateMySubmissionInput(index, key, value) {
  return {
    type: UPDATE_MYSUBMISSION_INPUT,
    index: index,
    key: key,
    value: value
  }
}

const GET_USERDETAILS_REQUEST = 'GET_USERDETAILS_REQUEST'
const GET_USERDETAILS_SUCCESS = 'GET_USERDETAILS_SUCCESS'
const GET_USERDETAILS_FAILURE = 'GET_USERDETAILS_FAILURE'

export {
  GET_USERDETAILS_REQUEST,
  GET_USERDETAILS_SUCCESS,
  GET_USERDETAILS_FAILURE
}

export function getUserDetailsRequest() {
  return {
    type: GET_USERDETAILS_REQUEST,
    loading: true
  }
}

export function getUserDetailsSuccess(body) {
  return {
    type: GET_USERDETAILS_SUCCESS,
    body: body,
    loading: false
  }
}

export function getUserDetailsFailure(error) {
  return {
    type: GET_USERDETAILS_FAILURE,
    error: error,
    loading: false
  }
}

export function getUserDetails(body, cb) {
  return function(dispatch) {
    dispatch(getUserDetailsRequest())
    superagent
    .get(config.BASE + '/api/userdetails')
    .withCredentials()
    .end((err, res) => {
      if (err) {
        //alert(err.response.body.message)
        dispatch(getUserDetailsFailure(err))
      } else {
        dispatch(getUserDetailsSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

const PATCH_USERDETAILS_REQUEST = 'PATCH_USERDETAILS_REQUEST'
const PATCH_USERDETAILS_SUCCESS = 'PATCH_USERDETAILS_SUCCESS'
const PATCH_USERDETAILS_FAILURE = 'PATCH_USERDETAILS_FAILURE'

export {
  PATCH_USERDETAILS_REQUEST,
  PATCH_USERDETAILS_SUCCESS,
  PATCH_USERDETAILS_FAILURE
}

export function patchUserIdRequest() {
  return {
    type: PATCH_USERDETAILS_REQUEST,
    loading: true
  }
}

export function patchUserIdSuccess(body) {
  return {
    type: PATCH_USERDETAILS_SUCCESS,
    body: body,
    loading: false
  }
}

export function patchUserIdFailure(error) {
  return {
    type: PATCH_USERDETAILS_SUCCESS,
    error: error,
    loading: false
  }
}

export function patchUserId(body, cb) {
  return function(dispatch) {
    dispatch(patchUserIdRequest())
    superagent
    .post(config.BASE + '/api/updateuserprofile')
    .send(body)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        //alert("Could Not Update Your Profile!")
        dispatch(patchUserIdFailure(err))
      } else {
        //alert("Profile Updated!")
        dispatch(patchUserIdSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

const GET_SUBMISSION_REQUEST = 'GET_SUBMISSION_REQUEST'
const GET_SUBMISSION_SUCCESS = 'GET_SUBMISSION_SUCCESS'
const GET_SUBMISSION_FAILURE = 'GET_SUBMISSION_FAILURE'

export {
  GET_SUBMISSION_REQUEST,
  GET_SUBMISSION_SUCCESS,
  GET_SUBMISSION_FAILURE
}

export function getSubmissionRequest() {
  return {
    type: GET_SUBMISSION_REQUEST,
    loading: true
  }
}

export function getSubmissionSuccess(body) {
  return {
    type: GET_SUBMISSION_SUCCESS,
    body: body,
    loading: false
  }
}

export function getSubmissionFailure(error) {
  return {
    type: GET_SUBMISSION_FAILURE,
    error: error,
    loading: false
  }
}

export function getSubmission(body, cb) {
  return function(dispatch) {
    dispatch(getSubmissionRequest())
    superagent
    .get(config.BASE + '/api/editorsubmissionavail')
    .withCredentials()
    .end((err, res) => {
      if (err) {
        //alert(err.response.body.message)
        dispatch(getSubmissionFailure(err))
      } else {
        dispatch(getSubmissionSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

export function getStudSubmissionAvailRequest() {
  return {
    type: c.GET_STUDSUBMISSIONAVAIL_REQUEST,
    loading: true
  }
}

export function getStudSubmissionAvailSuccess(body) {
  return {
    type: c.GET_STUDENT_SUBMISSIONS_SUCCESS,
    body: body,
    loading: false
  }
}

export function getStudSubmissionAvailFailure(error) {
  return {
    type: c.GET_STUDSUBMISSIONAVAIL_FAILURE,
    error: error,
    loading: false
  }
}

export function getStudentPapers(page, body, cb) {
  var pager = '';
  if(page) {
    pager = '?page='+page;
  }
  return function(dispatch) {
    dispatch(getStudSubmissionAvailRequest())
    superagent
    .get(config.BASE + 'api/student/papers'+pager)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        // //alert("Error getting student data ");
        dispatch(getStudSubmissionAvailFailure(err))
      } else {
        console.log("This is the result, ", res);
        dispatch(getStudSubmissionAvailSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

const GET_STUDSUBMISSIONCOMPLETE_REQUEST = 'GET_STUDSUBMISSIONCOMPLETE_REQUEST'
const GET_STUDSUBMISSIONCOMPLETE_SUCCESS = 'GET_STUDSUBMISSIONCOMPLETE_SUCCESS'
const GET_STUDSUBMISSIONCOMPLETE_FAILURE = 'GET_STUDSUBMISSIONCOMPLETE_FAILURE'

export {
  GET_STUDSUBMISSIONCOMPLETE_REQUEST,
  GET_STUDSUBMISSIONCOMPLETE_SUCCESS,
  GET_STUDSUBMISSIONCOMPLETE_FAILURE
}

export function getStudSubmissionCompleteRequest() {
  return {
    type: GET_STUDSUBMISSIONCOMPLETE_REQUEST,
    loading: true
  }
}

export function getStudSubmissionCompleteSuccess(body) {
  return {
    type: GET_STUDSUBMISSIONCOMPLETE_SUCCESS,
    body: body,
    loading: false
  }
}

export function getStudSubmissionCompleteFailure(error) {
  return {
    type: GET_STUDSUBMISSIONCOMPLETE_FAILURE,
    error: error,
    loading: false
  }
}

export function getStudSubmissionComplete(page, body, cb) {
  var pager = '';
  if(page) {
    pager = '?page='+page;
  }
  return function(dispatch) {
    dispatch(getStudSubmissionCompleteRequest())
    superagent
    .get(config.BASE + 'api/student/papersCompleted'+pager)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        // //alert("Error getting complete submission data ");
        dispatch(getStudSubmissionCompleteFailure(err))
      } else {
        dispatch(getStudSubmissionCompleteSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

const GET_COMPLETESUBMISSION_REQUEST = 'GET_COMPLETESUBMISSION_REQUEST'
const GET_COMPLETESUBMISSION_SUCCESS = 'GET_COMPLETESUBMISSION_SUCCESS'
const GET_COMPLETESUBMISSION_FAILURE = 'GET_COMPLETESUBMISSION_FAILURE'

export {
  GET_COMPLETESUBMISSION_REQUEST,
  GET_COMPLETESUBMISSION_SUCCESS,
  GET_COMPLETESUBMISSION_FAILURE
}

export function getCompleteSubmissionRequest() {
  return {
    type: GET_COMPLETESUBMISSION_REQUEST,
    loading: true
  }
}

export function getCompleteSubmissionSuccess(body) {
  return {
    type: GET_COMPLETESUBMISSION_SUCCESS,
    body: body,
    loading: false
  }
}

export function getCompleteSubmissionFailure(error) {
  return {
    type: GET_COMPLETESUBMISSION_FAILURE,
    error: error,
    loading: false
  }
}

export function getCompletedSubmissions(body, cb){
    return function(dispatch) {
      dispatch(getCompleteSubmissionRequest())
      superagent
      .get(config.BASE + 'api/completesubmissions')
      .withCredentials()
      .end((err, res) => {
        if (err) {
          //alert("Could not retrieve your completed edits")
          dispatch(getCompleteSubmissionFailure(err))
        } else {
          dispatch(getCompleteSubmissionSuccess(res.body))
          if (cb) {
            cb(res.body)
          }
        }
      })
    }
}

// -------- NO CHANGES BELOW THIS LINE --------
const GET_MYSUBMISSION_REQUEST = 'GET_MYSUBMISSION_REQUEST'
const GET_MYSUBMISSION_SUCCESS = 'GET_MYSUBMISSION_SUCCESS'
const GET_MYSUBMISSION_FAILURE = 'GET_MYSUBMISSION_FAILURE'

export {
  GET_MYSUBMISSION_REQUEST,
  GET_MYSUBMISSION_SUCCESS,
  GET_MYSUBMISSION_FAILURE
}

export function getMySubmissionRequest() {
  return {
    type: c.GET_EDITOR_AVAILABLE_TO_EDIT_REQUEST,
    loading: true
  }
}

export function getMySubmissionSuccess(body) {
  return {
    type: c.GET_EDITOR_AVAILABLE_TO_EDIT_SUCCESS,
    body: body,
    loading: false
  }
}

export function getMySubmissionFailure(error) {
  return {
    type: c.GET_EDITOR_AVAILABLE_TO_EDIT_FAILURE,
    error: error,
    loading: false
  }
}

export function getPossiblePapersForEdit(body, cb) {
  return function(dispatch) {
    dispatch(getMySubmissionRequest())
    superagent
    .get(config.BASE + 'api/editor/papers')
    .withCredentials()
    .end((err, res) => {
      if (err) {
        //alert("Could not retrieve your dashboard information")
        dispatch(getMySubmissionFailure(err))
      } else {
        console.log("Checking on my edits");
        dispatch(getMySubmissionSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

const POST_SUBMISSIONEDIT_REQUEST = 'POST_SUBMISSIONEDIT_REQUEST'
const POST_SUBMISSIONEDIT_SUCCESS = 'POST_SUBMISSIONEDIT_SUCCESS'
const POST_SUBMISSIONEDIT_FAILURE = 'POST_SUBMISSIONEDIT_FAILURE'

export {
  POST_SUBMISSIONEDIT_REQUEST,
  POST_SUBMISSIONEDIT_SUCCESS,
  POST_SUBMISSIONEDIT_FAILURE
}

export function postSubmissionEditRequest() {
  return {
    type: POST_SUBMISSIONEDIT_REQUEST,
    loading: true
  }
}

export function postSubmissionEditSuccess(body) {
  return {
    type: POST_SUBMISSIONEDIT_SUCCESS,
    body: body,
    loading: false
  }
}

export function postSubmissionEditFailure(error) {
  return {
    type: POST_SUBMISSIONEDIT_FAILURE,
    error: error,
    loading: false
  }
}

export function postSubmissionEdit(body, cb) {
  return function(dispatch) {
    dispatch(postSubmissionEditRequest())
    superagent
    .post(config.BASE + '/api/accepttoedit')
    .send(body)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        //alert("Could not Accept Edit at this time. Please refresh the page and try again. ")
        dispatch(postSubmissionEditFailure(err))
      } else {
        dispatch(postSubmissionEditSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

const POST_EDITEDPAPER_REQUEST = 'POST_EDITEDPAPER_REQUEST'
const POST_EDITEDPAPER_SUCCESS = 'POST_EDITEDPAPER_SUCCESS'
const POST_EDITEDPAPER_FAILURE = 'POST_EDITEDPAPER_FAILURE'

export {
  POST_EDITEDPAPER_REQUEST,
  POST_EDITEDPAPER_SUCCESS,
  POST_EDITEDPAPER_FAILURE
}

export function postEditedPaperRequest() {
  console.log('postEditedPaperRequest ---?>>>>---?>>>>---?>>>>')
  return {
    type: POST_EDITEDPAPER_REQUEST,
    loading: true
  }
}

export function postEditedPaperSuccess(body) {
  return {
    type: POST_EDITEDPAPER_SUCCESS,
    body: body,
    loading: false
  }
}

export function postEditedPaperFailure(error) {
  return {
    type: POST_EDITEDPAPER_FAILURE,
    error: error,
    loading: false
  }
}

export function postEditedPaper(paper, submissionId, type, cb) {
  return function(dispatch) {
    console.log("INside post edited paper -----? ")
    var uri;
    if (type == 1) {
         uri = '/api/paperedited1'
    }else if (type == 2) {
         uri = '/api/paperedited2'
    }
    dispatch(postEditedPaperRequest())
    superagent
    .post(config.BASE + uri)
    .attach('paper', paper)
    .field('SubmissionId', submissionId)
    .field('Type', type)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        //alert("There was a problem uploading this paper")
        dispatch(postEditedPaperFailure(err))
      } else {
        dispatch(postEditedPaperSuccess(res.body))
        if (cb) {
          cb()
        }
      }
    })
  }
}

// --------------------------------------------------------
const GET_USER_DETAILS_REQUEST = 'GET_USER_DETAILS_REQUEST';
const GET_USER_DETAILS_SUCCESS = 'GET_USER_DETAILS_SUCCESS';
const GET_USER_DETAILS_FAILURE = 'GET_USER_DETAILS_FAILURE';
export {
    GET_USER_DETAILS_REQUEST,
    GET_USER_DETAILS_SUCCESS,
    GET_USER_DETAILS_FAILURE
}

export function getSingleUser(UserID){
    return function(dispatch) {
      superagent
      .get(config.BASE + '/api/submission/userdetails?userid=' + (UserID || ""))
      .withCredentials()
      .end((err, res) => {
          if (err) {
              //alert("Could not receive document details")
              dispatch(getSingleUserFailure(err))
          } else {
              dispatch(getSingleUserSuccess(res.body))
          }
      })
    }
}

export function getSingleUserSuccess(body){
    return {
      type: GET_USER_DETAILS_SUCCESS,
      body: body
    }
}

export function getSingleUserFailure(body){
    return {
      type: GET_USER_DETAILS_FAILURE,
      body: body
    }
}

 // --------------------------------------------------------

// --------------------------------------------------------
const GET_DOCUMENT_DETAILS_REQUEST = 'GET_DOCUMENT_DETAILS_REQUEST';
const GET_DOCUMENT_DETAILS_SUCCESS = 'GET_DOCUMENT_DETAILS_SUCCESS';
const GET_DOCUMENT_DETAILS_FAILURE = 'GET_DOCUMENT_DETAILS_FAILURE';
export {
    GET_DOCUMENT_DETAILS_REQUEST,
    GET_DOCUMENT_DETAILS_SUCCESS,
    GET_DOCUMENT_DETAILS_FAILURE
}

export function getSingleDocument(DocID, cb){
    return function(dispatch) {
      superagent
      .get(config.BASE + 'api/student/paperdetails?docid=' + (DocID || ""))
      .withCredentials()
      .end((err, res) => {
          if (err) {
              //alert("Could not receive document details")
              dispatch(getSingleDocumentFailure(err))
          } else {
              dispatch(getSingleDocumentSuccess(res.body))
              if(cb) {
                cb(res.body);
              }
          }
      })
    }
}

export function getSingleDocumentSuccess(body){
    return {
      type: GET_DOCUMENT_DETAILS_SUCCESS,
      body: body
    }
}

export function getSingleDocumentFailure(body){
    return {
      type: GET_DOCUMENT_DETAILS_FAILURE,
      body: body
    }
}

const POST_EDITEDPAPERCOMPLETE_REQUEST = 'POST_EDITEDPAPERCOMPLETE_REQUEST'
const POST_EDITEDPAPERCOMPLETE_SUCCESS = 'POST_EDITEDPAPERCOMPLETE_SUCCESS'
const POST_EDITEDPAPERCOMPLETE_FAILURE = 'POST_EDITEDPAPERCOMPLETE_FAILURE'

export {
  POST_EDITEDPAPERCOMPLETE_REQUEST,
  POST_EDITEDPAPERCOMPLETE_SUCCESS,
  POST_EDITEDPAPERCOMPLETE_FAILURE
}

export function postEditedPaperCompleteRequest() {
  return {
    type: POST_EDITEDPAPERCOMPLETE_REQUEST,
    loading: true
  }
}

export function postEditedPaperCompleteSuccess(body) {
  return {
    type: POST_EDITEDPAPERCOMPLETE_SUCCESS,
    body: body,
    loading: false
  }
}

export function postEditedPaperCompleteFailure(error) {
  return {
    type: POST_EDITEDPAPERCOMPLETE_FAILURE,
    error: error,
    loading: false
  }
}

export function postEditedPaperComplete(wordCount, submissionId, cb) {
  return function(dispatch) {
    dispatch(postEditedPaperCompleteRequest())
    superagent
    .post(config.BASE + '/api/papercompleted')
    .send({
        SubmissionId: submissionId
    })
    .withCredentials()
    .end((err, res) => {
      if (err) {
        //alert("We could not accept this completed paper! ")
        dispatch(postEditedPaperCompleteFailure(err))
      } else {
        dispatch(postEditedPaperCompleteSuccess(res.body))
        if (cb) {
          cb()
        }
      }
    })
  }
}

export function editsThatHaveChanged() {
  return function(dispatch) {
    superagent
    .get(config.BASE + '/editsupdated')
  }
}



// WEBPACK FOOTER //
// ./src/actions/studentdashboard.js